import { RouterProvider, createBrowserRouter } from "react-router-dom";
import AppRoutes from "./routes";
import AppError from "./components/AppError";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { DecksProvider } from "./context/DecksContext";
import { useContext, useEffect } from "react";
import AuthContext from "./context/AuthContext";
import { setLogoutHandler } from "./services/api";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./constants";

// A data router (not <BrowserRouter>) so pages can use useBlocker — the
// drawing editor holds navigation while leaving would lose work. The whole
// existing <Routes> tree hangs off one catch-all route, so every page and
// component test that renders <Routes> under a MemoryRouter is unchanged.
// Relative navigation (navigate(".."), relative <Link to>) would resolve
// against that catch-all route, so the app uses absolute paths throughout.
// errorElement: a page that crashes (or a lazy chunk a new deploy removed)
// shows mono's own "Reload" page, not React Router's default stack trace.
const router = createBrowserRouter([
  { path: "*", element: <AppRoutes />, errorElement: <AppError /> },
]);

// Dev only: a hot-reloaded App.jsx makes a new router; retire the old one's
// history listener.
if (import.meta.hot) import.meta.hot.dispose(() => router.dispose());

function AppContent() {
  const { logout } = useContext(AuthContext);

  // Wire up the API interceptor to use the logout function
  useEffect(() => {
    setLogoutHandler(logout);
  }, [logout]);

  return <RouterProvider router={router} />;
}

function App() {
  const content = (
    <ThemeProvider>
      <AuthProvider>
        <DecksProvider>
          <AppContent />
        </DecksProvider>
      </AuthProvider>
    </ThemeProvider>
  );

  if (GOOGLE_CLIENT_ID) {
    return (
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        {content}
      </GoogleOAuthProvider>
    );
  }

  return content;
}

export default App;
